import React from 'react'
import { useSelector } from 'react-redux';
import desktopScreen from 'assets/images/screenshot_desktop.png';
import desktopScreenAr from 'assets/images/screenshot_desktop-ar.png';
import phoneScreen from 'assets/images/screenshot_phone.png';
import phoneScreenAr from 'assets/images/screenshot_phone-ar.png';
import circle from 'assets/images/circle_bg.svg';

import messages from 'assets/Local/messages';

import './DemoView.scss'
import { Link } from 'react-router-dom';

const DemoView = () => {
	const lang = useSelector((state) => state.locale.lang);
	const message = messages[lang];

  return (
    <div className="DemoView">
      <div className='container d-flex align-items-center overflow-hidden'>
        <div className='phone' data-aos={lang==='en'?'fade-right':'fade-left'}  data-aos-duration="1500" data-aos-offset="300">
          <div className="phone-image">

            <img src={lang==='en'?phoneScreen:phoneScreenAr} alt="" className='w-100'/>
          </div>
          <Link to='/registration'>
            <button className='text-white btn-primary text-uppercase bold_font px-5 px-sm-4 px-lg-5 py-3'>{message.tryFree}</button>
          </Link>
        </div>
        <div className='desktop' data-aos={lang==='en'?'fade-left':'fade-right'}  data-aos-duration="1500" data-aos-offset="300">
          <img src={lang==='en'?desktopScreen:desktopScreenAr} alt="" className='w-100'/>
        </div>
      </div>
    </div>
  )
}

export default DemoView